(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("userful-chronos-common-ui", [], factory);
	else if(typeof exports === 'object')
		exports["userful-chronos-common-ui"] = factory();
	else
		root["userful-chronos-common-ui"] = factory();
})(this, () => {
return 